export default {
  allTime: 'All The Time',
  aDay: 'Within A Day',
  threeDays: 'Within Three Days',
  AWeek: 'Within A Week',
  AMonth: 'Within A Month',
  reject: 'Repel',
  resolve: 'Pass',
  loading: 'loading...',
  language: 'English',
  pending: 'Pending',
  approved: 'Approved',
  noMore: 'No More',
  prompt: 'Prompt',
  notation: 'Notation',
  notationPrompt: 'Please enter comments',
  confirm: 'Has it been approved?',
  detail: 'Detail',
  suc: 'success',
  fail: 'failed',
  record: 'Approval Records',
  flowNum: 'ApproveNumber',
  flowCode: 'FlowCode',
  flowName: 'FlowName',
  promoter: 'Promoter',
  startTime: 'StartTime',
  endTime: 'EndTime',
  empty: 'Content is empty',
  allProcess: 'All Process',
  enSure: 'Confirm',
  cancel: 'Cancel',
  title: 'Process Approval',
  search: 'Search',
  requiredFields: 'Please complete the required fields',
  updateFailed: 'Failed to update data. Please try again later'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js